import { AppActionTypes } from 'types/store/actions/constants';
import { AppState, AppActions } from 'types/store/reducers/app';

const initialState: AppState = {
  error: '',
};

export default (state = initialState, action: AppActions): AppState => {
  switch (action.type) {
    case AppActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload || 'Something went wrong',
      };
    case AppActionTypes.CLEAN_ERROR:
      return {
        ...state,
        error: '',
      };
    default:
      return state;
  }
};
